<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("floatAmount") }}</div>
      </div>

      <div class="d-flex align-items-center">
        <div>
          <b-button v-if="$can('create', 'Float Amount')" variant="default"
            :to="`add-float-amount?cinema_id=${String(encryptString(String(cinema_id || dropDown['selectedCinemaId'])))}`"
            class="btn-blue">{{ $t("add") }}</b-button>
        </div>
        <div class="d-flex align-items-center"></div>
      </div>
    </div>
    <div class="w-full d-flex justify-content-between align-items-cetner mt-2">
      <div class="col-4">
        <div class="dropdown-curve-container">
          <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
              ? 'shift-up'
              : ''
            ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
          <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
            :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
            @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
        </div>
      </div>
      <div class="searchbar-rounded">
        <input v-debounce:500="onSearch" v-model="searchValue" type="search" placeholder="Search" />
      </div>
      <div class="d-flex justify-content-end">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
              @click="onDropDownChangeValue(list.name)">{{ list.name }}</b-dropdown-item>
          </b-dropdown>
        </div>
        <b-button variant="default" @click="onFetch()" class="btn-blue">{{
          $t("fetch")
        }}</b-button>
      </div>
    </div>
    <div class="white-wrapper mt-3">
      <table class="table table-bordered">
        <thead style="text-align: center">
          <tr>
            <th scope="col" class="text-center">{{ $tc("status", 1) }}</th>
            <th>
              <img v-if="this.columnName != 'operator_user'" @click="onSortValue('operator_user', 'asc')"
                src="@/assets/img/icons/updown.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else-if="isSort && isAscending" @click="onSortValue('operator_user', 'asc')"
                src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="onSortValue('operator_user', 'desc')" src="@/assets/img/icons/desc.svg"
                class="cursor-pointer" width="15px" height="20px" />
              {{ $t("name") }}
            </th>
            <th scope="col">{{ $tc("shift", 1) }}</th>
            <th scope="col" class="text-center">{{ $t("manager") }}</th>
            <th scope="col" class="text-center">
              <img v-if="this.columnName != 'created_at'" @click="onSortValue('created_at', 'asc')"
                src="@/assets/img/icons/updown.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else-if="isSort && isAscending" @click="onSortValue('created_at', 'asc')"
                src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="onSortValue('created_at', 'desc')" src="@/assets/img/icons/desc.svg"
                class="cursor-pointer" width="15px" height="20px" />
              {{ $t("date") }}
            </th>
            <th scope="col" class="text-center">{{ $t("amount") }}</th>
          </tr>
        </thead>
        <tbody v-if="CinemaFloatAmounts.length > 0">
          <tr v-for="(
CinemaFloatAmount, CinemaFloatAmountIndex
            ) in CinemaFloatAmounts" :key="CinemaFloatAmountIndex" class="light_grey_back">
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <StatusDot :status="CinemaFloatAmount.float_is_active === 'Y'
                    ? 'active'
                    : 'inactive'
                  " />
                <span v-if="$can('update', 'Float Amount')" class="edit-icon ml-4 blue-icon" @click="
                  goToRoute(
                    '/cinema-manager/edit-float-amount',
                    CinemaFloatAmount
                  )
                  " style="cursor: pointer" v-b-tooltip="'Edit'" tabindex="0">
                  <i class="edit-pen icon blue-icon"></i>
                </span>
                <span class="view-icon ml-2 blue-icon" @click="
                  goToRoute(
                    '/cinema-manager/view-float-amount',
                    CinemaFloatAmount
                  )
                  " style="cursor: pointer" v-b-tooltip="'View'" tabindex="0">
                  <i class="icon-eye icon blue-icon"></i>
                </span>
              </div>
            </td>

            <td>{{ CinemaFloatAmount.operator_user }}</td>
            <td>{{ CinemaFloatAmount.shift_name }}</td>
            <td class="text-left">{{ CinemaFloatAmount.manager_user }}</td>
            <td class="text-right">
              {{ CinemaFloatAmount.created_at | dateparse }}
            </td>
            <td class="text-right">
              {{ CinemaFloatAmount.float_amount_given }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination style="margin-bottom: 0px" v-if="CinemaFloatAmounts.length > 0" v-model="currentPage"
        :total-rows="rows" @change="onChangePagination($event)" :per-page="perPage"
        aria-controls="my-table"></b-pagination>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { encryptString } from "@/helper/collection"

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "0",
      CinemaFloatAmounts: [],
      cinema_id: null,
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      searchValue: "",
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    this.getCinemaList();
    this.getviewingnumber();
    // this.getCinemaFloatAmountList(obj);
  },
  mounted() { },
  methods: {
    encryptString,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.cinema_id = event['cine_id']
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    onSearch(event) {
      this.searchValue = event;
      this.currentPage = 1;
      this.getCinemaFloatAmountList(this.cinema_id);
    },
    onFetch: function () {
      this.getCinemaFloatAmountList(this.cinema_id);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCinemaFloatAmountList(this.cinema_id);
      } else {
        this.currentPage = event;
        this.getCinemaFloatAmountList(this.cinema_id);
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCinemaFloatAmountList(this.cinema_id);
    },
    getCinemaFloatAmountList: function (cinema_id) {
      if (!cinema_id || !this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Please select cinema")
      }
      this.CinemaFloatAmounts = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: cinema_id || this.dropDown.selectedCinemaId,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
      };
      CinemasService.GetFloatAmount(payload)
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.CinemaFloatAmounts = data.Records;
              if (data.totalRows > 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, item) {
      const { float_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: float_id,
          cinema_id: encryptString(String(this.cinema_id))
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FloatAmountComponents/floatAmount.vue